import { Box, Button, Container, Paper, styled, Typography } from '@mui/material';
import { FC, useCallback, useContext, useMemo } from 'react';
import { ClientConfigurationContext, ActiveDirectoryLoginForm } from '@ngt/openiddict';
import { useLocation } from 'react-router-dom';
import { parse } from 'qs';
import useNavigate from '@/hooks/router/useNavigate';
import useQueryString from '@/hooks/router/useQueryString';

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2)
}))

const qsValues = [
    {
        key: 'redirectUrl' as 'redirectUrl',
        names: [
            'redirecturl',
            'returnurl',
            'returnuri'
        ]
    },
    {
        key: 'impersonate' as 'impersonate',
        names: [
            'impersonate'
        ]
    }
]

const Login: FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const currentLocation = useMemo(() => `${location.pathname}${location.search}${location.hash}`, [location]);

    const {redirectUrl, impersonate} = useQueryString(qsValues);

    const redirectQuery = useMemo(() => {
        if (!redirectUrl) {
            return undefined;
        }

        if (!redirectUrl.includes('?')) {
            return undefined;
        }

        return redirectUrl.substring(redirectUrl.indexOf('?'));
    }, [redirectUrl]);

    
    const {impersonate: redirectImpersonate} = useQueryString(qsValues, redirectQuery);

    const onAction = useCallback(async (url: string) => {
        navigate(url);
    }, [navigate]);

    const onLogin = useCallback(async (url: string) => {
        navigate(url, undefined, 'Logging In...');
    }, [navigate]);

    return (
        <Container maxWidth="md">
            <Typography variant="h1" gutterBottom>
                Login
            </Typography>
            <StyledPaper>
                <ActiveDirectoryLoginForm
                    currentUrl={currentLocation}
                    redirectUrl={redirectUrl}
                    impersonate={impersonate ?? redirectImpersonate}
                    debug={import.meta.env.DEV}
                    onCancel={redirectUrl && !redirectUrl.startsWith('/') ? onAction : undefined}
                    onLogin={onLogin}
                    onForgotPassword={onAction}
                />
            </StyledPaper>
        </Container>
    );
}

export default Login;